import React from 'react';

import { InboxProvider } from 'ha/pages/InboxNext/context/InboxProvider';
import { ContactUs } from './components/ContactUs';

const ContactUsPageRoot: React.FC = () => {
  return (
    <InboxProvider>
      <ContactUs />
    </InboxProvider>
  );
};

export { ContactUsPageRoot };
